<template>
    <div class="modal fade" id="builder_modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content SocialOrganicInstagramGrid">
                <div class="modal-header padding-x15 padding-y10">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-4 select-element-name">
                            <h6>Name your element</h6>
                            <div>
                                <input v-model="name" type="text" class="form-control">
                                <div class="invalid-feedback">Element with name {{ name }} already exists.</div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <ul class="nav nav-tabs nav-fill" id="social_organic_instagram_grid_tabs" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="grid_tab" data-toggle="tab" href="#grid" role="tab" aria-controls="grid" aria-selected="true">GRID</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="highlight_tab" data-toggle="tab" href="#highlight" role="tab" aria-controls="highlight" aria-selected="false">SELECTED</a>
                        </li>
                    </ul>

                    <div class="tab-content" id="social_organic_instagram_grid_tab_content">
                        <div class="tab-pane show active padding-top15" id="grid" role="tabpanel" aria-labelledby="grid_tab">
                            <div class="row">
                                <div class="col-4">
                                    <h6>Name</h6>
                                    <div>
                                        <input v-model="extra_data.grid" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane padding-top15" id="highlight" role="tabpanel" aria-labelledby="highlight_tab">
                            <div class="row">
                                <div class="col-4">
                                    <h6>Name</h6>
                                    <div>
                                        <input v-model="extra_data.selected" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer padding-y10">
                    <button :disabled="build_disabled" @click="buildElement" type="button" class="btn btn-success">{{ edit_mode ? 'Update' : 'Build' }} Element</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            this.element   = this.$store.getters.getBuilderPopupParams.element;
            this.edit_mode = this.$store.getters.getBuilderPopupParams.edit_mode || false;

            Object.assign(this.$data, vm.customClone(this.$store.getters.getBuilderPopupParams.data || {}));

            if (this.extra_data === null) {
                this.extra_data = {
                    grid:     '',
                    selected: ''
                }
            }

            this.validate();
        },

        data() {
            return {
                name:           '',
                original_name:  '',
                element:        {},
                build_disabled: true,
                edit_mode:      false,

                extra_data: {
                    grid:     '',
                    selected: ''
                }
            }
        },

        methods: {
            buildElement() {
                if (!this.edit_mode) {
                    this.$store.commit('addBuilderElement', {
                        name:                 this.name || this.$parent.generateElementName(),
                        element_id:           this.element.id,
                        element_abbreviation: this.element.abbreviation,
                        extra_data:           this.extra_data
                    });
                } else {
                    this.$store.commit('updateBuilderElement', {
                        data: {
                            name:                 this.name || this.$parent.generateElementName(),
                            element_id:           this.element.id,
                            element_abbreviation: this.element.abbreviation,
                            extra_data:           this.extra_data
                        },

                        name: this.$store.getters.getBuilderPopupParams.data.original_name
                    });
                }

                event_bus.$emit('element_saved', true);

                $('#builder_modal').modal('hide');
            },

            changeConfig(configId, value) {
                if (typeof value === 'boolean') {
                    if (value === true) {
                        this.configurations[configId] = 'true';
                    } else {
                        delete this.configurations[configId];
                    }
                } else {
                    this.configurations[configId] = value;
                }

                this.$forceUpdate();
            },

            validate() {
                this.build_disabled = true;

                if (
                    _.findIndex(this.$store.getters.getBuilderElements, {name: this.name}) === -1
                    || (this.edit_mode && this.$store.getters.getBuilderPopupParams.data.name === this.name)
                ) {
                    this.build_disabled = false;
                }
            }
        },

        watch: {
            name() {
                if (this.name) {
                    if (
                        _.findIndex(this.$store.getters.getBuilderElements, {name: this.name}) === -1
                        || (this.edit_mode && this.$store.getters.getBuilderPopupParams.data.name === this.name)
                    ) {
                        $('#builder_modal').find('.select-element-name input').removeClass('is-invalid');
                    } else {
                        $('#builder_modal').find('.select-element-name input').addClass('is-invalid');
                    }
                }

                this.validate();
            }
        }
    }
</script>

<style lang="scss" scoped>
    #social_organic_instagram_grid_tab_content {
        padding: 0 1.5rem 1.5rem;
        border-left: 0.1rem solid #dee2e6;
        border-right: 0.1rem solid #dee2e6;
        border-bottom: 0.1rem solid #dee2e6;
        border-bottom-left-radius: .5rem;
        border-bottom-right-radius: .5rem;
    }

    .close {
        outline: none;
    }

    .nav-tabs {
        a.nav-link {
            font-weight: 500;
            font-size: 1.2rem;
            color: #37a8cd;

            &.active {
                box-shadow: 0 -0.1rem .3rem #eeeeee;
                color: #37a8cd;
                background-color: #ffffff;
                border-color: #dee2e6 #dee2e6 #ffffff;
            }
        }
    }
</style>
